const translation: Record<string, string> = {
  "nav.categories": "Категории",
  "nav.buy_now": "Купить сейчас",
  "nav.home": "Главная",

  "hero.title": "YOYBUY SHEET",
  "hero.subtitle": "Умная система заказов из Китая через spreadsheet. Экономьте до 40% на каждой покупке с прозрачными ценами и быстрой доставкой в Россию.",
  "hero.cta_primary": "YOYBUY SHEET",
  "hero.cta_secondary": "КУПИТЬ СЕЙЧАС",
  "hero.popular": "Популярное",

  "features.title_small": "Полезные материалы",
  "features.title": "Руководства Yoybuy Sheet",
  "features.title_line2": "Экономия и скорость",
  "features.card1_title": "Что такое Spreadsheet",
  "features.card1_desc": "Узнайте, как работает система заказов через электронные таблицы и почему это выгоднее традиционных посредников.",
  "features.card2_title": "Сравнение агентов",
  "features.card2_desc": "Детальный обзор Yoybuy, Kakobuy и Superbuy: цены, скорость доставки, комиссии и надёжность.",
  "features.card3_title": "Как заказать из России",
  "features.card3_desc": "Пошаговая инструкция для покупателей из России: от выбора товара до получения посылки на Почте России.",
  "features.read_article": "Читать статью →",

  "categories.title": "Топ категории",
  "categories.subtitle": "Самые популярные товары через Yoybuy Spreadsheet",
  "categories.view_all": "Смотреть все →",

  "seo.title": "Yoybuy Spreadsheet — ваш проводник в мир китайского шопинга",
  "seo.paragraph1": "Yoybuy Spreadsheet — это инновационная система заказа товаров из Китая, которая использует привычный формат электронных таблиц для максимальной прозрачности и удобства. В отличие от традиционных агентов и посредников, Yoybuy предлагает прямой доступ к миллионам товаров с фабрик и маркетплейсов Китая без скрытых наценок и комиссий.",
  "seo.paragraph2": "Система spreadsheet-заказов работает предельно просто: вы заполняете таблицу ссылками на интересующие товары, указываете размеры и цвета, а команда Yoybuy берёт на себя весь процесс — от выкупа у поставщика до международной доставки. Каждый этап отслеживается в реальном времени, а итоговая стоимость известна заранее, без неприятных сюрпризов.",
  "seo.paragraph3": "Для покупателей из России и стран СНГ Yoybuy Spreadsheet стал настоящим открытием. Возможность заказывать кроссовки, одежду, электронику и аксессуары напрямую с китайских складов по ценам производителя — это то, что меняет правила игры. Добавьте к этому русскоязычную поддержку и отлаженную логистику, и вы получите идеальный инструмент для выгодного онлайн-шопинга.",
  "seo.read_guide": "Читать руководство Yoybuy Sheet →",
  "seo.stat1_value": "12К+",
  "seo.stat1_label": "Заказов через sheet",
  "seo.stat2_value": "14",
  "seo.stat2_label": "Категорий товаров",
  "seo.stat3_value": "7",
  "seo.stat3_label": "Дней доставка",
  "seo.image_label": "Yoybuy Guide",

  "testimonials.label": "Отзывы покупателей",
  "testimonials.title": "Что говорят наши",
  "testimonials.title_line2": "клиенты",
  "testimonial.1.name": "Алексей Петров",
  "testimonial.1.handle": "@alex_petro",
  "testimonial.1.text": "Заказал кроссовки через Yoybuy Spreadsheet — всё прошло идеально. Цена в два раза ниже, чем в московских магазинах, доставка заняла 9 дней. Таблица с трекингом очень удобная!",
  "testimonial.2.name": "Екатерина Смирнова",
  "testimonial.2.handle": "@kat_smir",
  "testimonial.2.text": "Пользуюсь Yoybuy Sheet уже полгода. Заказывала одежду, сумки и даже чехлы для телефона. Качество отличное, экономия огромная. Рекомендую всем подругам!",
  "testimonial.3.name": "Дмитрий Волков",
  "testimonial.3.handle": "@d_volkov",
  "testimonial.3.text": "Сравнивал Yoybuy с другими агентами — spreadsheet система реально удобнее. Всё прозрачно, без скрытых платежей. Отдельный плюс за русскоязычную поддержку.",
  "testimonial.4.name": "Анна Кузнецова",
  "testimonial.4.handle": "@anna_kuz",
  "testimonial.4.text": "Первый заказ через Yoybuy Spreadsheet делала с опаской, но зря переживала. Товар пришёл за 8 дней, упаковка целая, качество соответствует описанию. Теперь это мой основной способ покупок из Китая.",
  "testimonial.5.name": "Игорь Соколов",
  "testimonial.5.handle": "@igor_sokol",
  "testimonial.5.text": "Как реселлер, я постоянно ищу выгодные цены. Yoybuy Spreadsheet даёт доступ к товарам по ценам производителя с минимальной комиссией. За год сэкономил более 200 000 рублей.",
  "testimonial.6.name": "Мария Белова",
  "testimonial.6.handle": "@m_belova",
  "testimonial.6.text": "Лучший сервис для заказа брендовой одежды из Китая. Spreadsheet система позволяет сравнивать цены разных поставщиков и выбирать оптимальный вариант. Очень довольна!",

  "cta.title": "YOYBUY SHEET — НАЧНИ СЕЙЧАС",
  "cta.subtitle": "Экономьте до 40% на покупках из Китая с прозрачной системой spreadsheet-заказов",
  "cta.subtitle_line2": "Быстрая доставка в Россию, Казахстан и Беларусь",
  "cta.button": "ПЕРЕЙТИ НА KASPREADSHEET",

  "footer.col1_title": "Обувь и одежда",
  "footer.col2_title": "Низ и комплекты",
  "footer.col3_title": "Аксессуары",
  "footer.col4_title": "Другое",
  "footer.guide": "Yoybuy Guide",
  "footer.faq": "FAQ",
  "footer.brand": "YOYBUY",
  "footer.brand_sub": "SHEET",
  "footer.copyright": "© 2026 Yoybuy.rest — Ваш гид по spreadsheet-шопингу из Китая",
  "footer.description": "Yoybuy.rest — информационный ресурс о системе заказов Yoybuy Spreadsheet. Мы помогаем покупателям из России и СНГ находить лучшие товары из Китая по выгодным ценам.",

  "article.back_home": "← На главную",
  "article.read_more": "Читать далее",
  "article.related": "Похожие статьи",

  "category.shoes": "Обувь",
  "category.hoodies": "Худи и свитера",
  "category.tshirts": "Футболки",
  "category.jackets": "Куртки",
  "category.pants": "Штаны и шорты",
  "category.headwear": "Головные уборы",
  "category.sets": "Комплекты",
  "category.underwear": "Нижнее бельё",
  "category.jersey": "Джерси",
  "category.accessories": "Аксессуары",
  "category.bags": "Сумки",
  "category.belts": "Ремни",
  "category.perfumes": "Парфюмерия",
  "category.other": "Разное",
};

export default translation;